import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"

const badgeVariants = cva(
    "inline-flex items-center rounded-full border border-neutral-200 px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-accent-500 focus:ring-offset-2",
    {
        variants: {
            variant: {
                default:
                    "border-transparent bg-neutral-900 text-neutral-50 hover:bg-neutral-900/80",
                secondary:
                    "border-transparent bg-neutral-100 text-neutral-900 hover:bg-neutral-100/80",
                destructive:
                    "border-transparent bg-red-500 text-neutral-50 hover:bg-red-500/80",
                outline: "text-neutral-950",
                success: "border-transparent bg-green-500 text-white hover:bg-green-600",
                warning: "border-transparent bg-yellow-500 text-white hover:bg-yellow-600",
                info: "border-transparent bg-blue-500 text-white hover:bg-blue-600",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    }
)

export interface BadgeProps
    extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> { }

function Badge({ className, variant, ...props }: BadgeProps) {
    return (
        <div className={cn(badgeVariants({ variant }), className)} {...props} />
    )
}

export { Badge, badgeVariants }
